import React, { useEffect, useState } from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TablePagination,
} from '@mui/material';
import './AuditLog.css';
import axiosInstance from '../../axios/axios';
import moment from 'moment';

const style = {
    fontFamily: 'Times New Roman',
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '18.4px',
    color: '#000000',
    alignItems: 'center'
};

const AuditLogList = () => {
    const [auditLogs, setAuditLogs] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(25);

    useEffect(() => {
        const getauditlogs = async () => {
            try {
                const response = await axiosInstance.get("/users/auditlog"); // Adjust endpoint
                const { success, auditLog } = response.data;
                if (success === true) {
                    setAuditLogs(auditLog);
                } else {
                    setAuditLogs([]);
                }
            } catch (error) {
                console.error("Error fetching privileges:", error);
            }
        };
        getauditlogs();
    }, []);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    return (
        <div className="audit-log-list">
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <h2 className='logTitle'>Audit Logs</h2>
            </div>

            <TableContainer component={Paper}>
                <Table>
                    <TableHead style={{ backgroundColor: '#EEDEFF' }}>
                        <TableRow>
                            <TableCell sx={{ ...style, fontWeight: 700 }}>Sl No</TableCell>
                            <TableCell sx={{ ...style, fontWeight: 700 }}>Action</TableCell>
                            <TableCell sx={{ ...style, fontWeight: 700 }}>Performed By</TableCell>
                            <TableCell sx={{ ...style, fontWeight: 700 }}>Date</TableCell>
                            <TableCell sx={{ ...style, fontWeight: 700 }}>IP</TableCell>
                            <TableCell sx={{ ...style, fontWeight: 700 }}>Affected User/Item</TableCell>
                            <TableCell sx={{ ...style, fontWeight: 700 }}>Description</TableCell>
                            <TableCell sx={{ ...style, fontWeight: 700 }}>Status</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {auditLogs
                            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            .map((log, index) => (
                                <TableRow
                                    key={log.slNo}
                                    style={{ backgroundColor: index % 2 === 0 ? '#F6F6F6' : '#DAD9D9' }}
                                >
                                    <TableCell sx={style}>{page * rowsPerPage + index + 1}</TableCell>
                                    <TableCell sx={style}>{log.event_name}</TableCell>
                                    <TableCell sx={style}>{log.user_name}</TableCell>
                                    <TableCell sx={style}>{moment(log.event_date_time).format('DD-MM-YY HH:mm:ss')}</TableCell>
                                    <TableCell sx={style}>{log.event_ip}</TableCell>
                                    <TableCell sx={style}>{log.affected_item_user}</TableCell>
                                    <TableCell sx={{ ...style, fontWeight: 700 }}>{log.description}</TableCell>
                                    <TableCell sx={{ ...style, fontWeight: 700 }}>{log.status_label}</TableCell>
                                </TableRow>
                            ))}
                    </TableBody>
                </Table>
                <TablePagination
                    rowsPerPageOptions={[10, 25, 50]}
                    component="div"
                    count={auditLogs.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </TableContainer>
        </div>
    );
};

export default AuditLogList;
